import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe extends CurrencyPipe implements PipeTransform {

  transform(value: any, currencyCode: string, display = 'symbol-narrow'): any {
    const currency_decimals = window.localStorage.getItem('currency_decimals');
    const digitsInfo = '1.' + currency_decimals + '-' + currency_decimals;
    return super.transform(value, currencyCode, display, digitsInfo);
  }

}
